export const linkAction = { size: '20', color: '#057a83' };
export const listContact = { size: '25', color: '' };
export const copyAction = { size: '19', color: '#292d32' };
export const editAction = { size: '19', color: '#292d32' };
export const deleteAction = { size: '19', color: '#292d32' };
export const close = { size: '24', color: '#ffffff' };
export const save = { size: '19', color: '#000B' };
